/* Cold Brew free 4-pack (Nov 2026).
   Keeps exactly one free 4-pack line (property _coldbrew_gift) in the cart while the rest of the cart
   is at or over the threshold (only when the shopper presses "Add my free 4-pack", or automatically if Theme settings >
   Cold Brew offer > "Add the 4-pack automatically" is on; Ali 3 Nov: off), and removes it when the cart drops below. The automatic discount in
   Shopify Admin is what makes that line free. If the shopper removes the 4-pack, it is not re-added this
   session; the cart bar offers "Add it to my order" instead. Config comes from snippets/coldbrew-offer-config. */
(function () {
  var cfgEl = document.getElementById('ColdbrewOfferConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[coldbrew] config unreadable', e); return; }
  if (!cfg.thresholdCents || !cfg.giftVariantId || !cfg.property) { console.error('[coldbrew] config incomplete', cfg); return; }

  var DECLINED = 'coldbrewGiftDeclined';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, again = false, wantAdd = false;

  var live = document.createElement('div');
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  function say(text) { live.textContent = ''; window.setTimeout(function () { live.textContent = text; }, 60); }

  // sessionStorage can be blocked (private mode); then the 4-pack is simply re-added, which is the safe default.
  function declined() { try { return window.sessionStorage.getItem(DECLINED) === '1'; } catch (e) { return false; } }
  function setDeclined(on) { try { on ? window.sessionStorage.setItem(DECLINED, '1') : window.sessionStorage.removeItem(DECLINED); } catch (e) { /* storage blocked: see declined() */ } }

  // USD with an explicit $: the shop money format prints amounts without a symbol.
  function money(cents) { return '$' + (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2)); }
  function isGift(item) { return !!(item.properties && item.properties[cfg.property]); }
  function rest(cart) { return cart.items.reduce(function (sum, item) { return isGift(item) ? sum : sum + item.final_line_price; }, 0); }

  function request(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error(path + ' HTTP ' + r.status); return r.json(); });
  }

  function paintCards(cart) {
    var sub = rest(cart), has = cart.items.some(isGift), left = Math.max(0, cfg.thresholdCents - sub);
    var pct = Math.min(1, sub / cfg.thresholdCents);
    document.querySelectorAll('[data-coldbrew-card]').forEach(function (card) {
      var fill = card.querySelector('.cb-card__fill'), status = card.querySelector('[data-coldbrew-status]');
      if (fill) fill.style.setProperty('--cb-progress', pct.toFixed(3));
      card.classList.toggle('is-in', has);
      card.classList.toggle('is-over', !has && left === 0);
      var addBtn = card.querySelector('[data-coldbrew-add]');
      if (addBtn) { addBtn.hidden = has || left > 0; addBtn.disabled = false; }
      if (!status) return;
      if (has) status.textContent = card.dataset.msgIn;
      else if (left === 0) status.textContent = card.dataset.msgOver;
      else if (sub === 0) status.textContent = card.dataset.msgEmpty;
      else status.textContent = card.dataset.msgLeft.replace('{amount}', money(left));
    });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false;
    request('cart.js').then(function (cart) {
      var gifts = cart.items.filter(isGift);
      // US-only offer in USD. In another presentment currency the amounts are converted, so never add, and take out a 4-pack added earlier.
      var usd = cart.currency === 'USD';
      var over = usd && cart.items.length > gifts.length && rest(cart) >= cfg.thresholdCents;
      var steps = Promise.resolve();
      if (!over && gifts.length) {
        gifts.forEach(function (g) { steps = steps.then(function () { return request('cart/change.js', { id: g.key, quantity: 0 }); }); });
        changed = true;
        setDeclined(false);
        say('Free Cold Brew 4-pack removed. Your cart is under ' + money(cfg.thresholdCents) + '.');
      } else if (over && !gifts.length && (wantAdd || (cfg.autoAdd === true && !declined()))) {
        var props = {}; props[cfg.property] = '1';
        steps = request('cart/add.js', { items: [{ id: cfg.giftVariantId, quantity: 1, properties: props }] });
        changed = true;
        say('Free Cold Brew 4-pack added to your cart.');
      } else if (gifts.length > 1 || (gifts[0] && gifts[0].quantity > 1)) {
        gifts.forEach(function (g, i) { steps = steps.then(function () { return request('cart/change.js', { id: g.key, quantity: i === 0 ? 1 : 0 }); }); });
        changed = true;
      }
      wantAdd = false;
      return steps.then(function () { return changed ? request('cart.js') : cart; });
    }).then(function (cart) {
      if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
      paintCards(cart);
    }).catch(function (e) {
      console.error('[coldbrew] cart sync failed', e);
    }).then(function () {
      busy = false;
      if (again) { again = false; sync(); }
    });
  }

  // Shopper removes the free 4-pack: remember it for this session so it is not forced back in.
  document.addEventListener('click', function (e) {
    var remove = e.target.closest && e.target.closest('.cart__item--gift .cart__remove a');
    if (remove) setDeclined(true);
    var add = e.target.closest && e.target.closest('[data-coldbrew-add]');
    if (add) { e.preventDefault(); setDeclined(false); add.disabled = true; wantAdd = true; sync(); }
  }, true);

  document.addEventListener('cart:updated', sync);
  document.addEventListener('ajaxProduct:added', function () { window.setTimeout(sync, 400); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();

/* Cart bar animation (Ali 3 Nov): when the drawer re-renders, the bar fills from where it was, and when it reaches the
   free 4-pack (or the 4-pack is in) the cans settle in and the text and button rise in. Nothing moves for reduced motion. */
(function () {
  var KEY = 'coldbrewBarPrev', reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prev = null, ready = false;
  try { prev = JSON.parse(window.sessionStorage.getItem(KEY) || 'null'); } catch (e) { prev = null; /* storage blocked: first change just doesn't animate */ }
  function stage(bar) { return bar.classList.contains('is-in') ? 'in' : (bar.classList.contains('is-over') ? 'over' : 'under'); }
  function progress(fill) { return parseFloat(fill.style.getPropertyValue('--cb-progress')) || 0; }
  function run(bar) {
    if (bar.dataset.cbSeen) return;
    bar.dataset.cbSeen = '1';
    var fill = bar.querySelector('.cb-bar__fill');
    var now = { s: stage(bar), p: fill ? progress(fill) : 0 };
    var from = prev || (ready ? { s: 'under', p: 0 } : null);
    if (!reduce && from && fill && from.p !== now.p) {
      fill.style.transition = 'none';
      fill.style.setProperty('--cb-progress', from.p);
      void fill.offsetWidth;
      fill.style.transition = '';
      window.requestAnimationFrame(function () { fill.style.setProperty('--cb-progress', now.p); });
    }
    if (!reduce && from && from.s !== now.s && now.s !== 'under') bar.classList.add('cb-bar--celebrate');
    prev = now;
    try { window.sessionStorage.setItem(KEY, JSON.stringify(now)); } catch (e) { /* storage blocked: see above */ }
  }
  function scan() { document.querySelectorAll('[data-coldbrew-bar]').forEach(run); }
  scan(); ready = true;
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
